export default function first<T>(i: Generator<T> | T[]): T | null {
    return "next" in i ? i.next().value : i.length > 0 ? i[0] : null;
}
